
export type RangeValue<T> = {
	min: number
	max: number,
	value: T
}

export class RangeSelector<T> {
	ranges: RangeValue<T>[] = [];

	constructor(ranges: RangeValue<T>[]) {
		this.ranges = ranges;
	}

	addRange(min: number, max: number, value: T) {
		this.ranges.push({ min, max, value });
	}

	getValue(value: number): T | undefined {
		return this.ranges.find(range => value >= range.min && value <= range.max)?.value;
	}

	static create = <T>(ranges: RangeValue<T>[]) => new RangeSelector(ranges);
}